import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { EllipsisDropdownItem } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import { SETUP_BACKGROUND_IMAGE } from "app/pages/activation/configs";
import { AssetsService } from "app/services/AssetsService";

export const HomepageContainer = styled(Box)`
    background-image: url("${AssetsService.assetUrl(SETUP_BACKGROUND_IMAGE)}");
    background-size: 100%;
    background-position: top left;
    background-repeat: no-repeat;
    overflow: auto;
    width: 100%;
    height: 100%;
    padding: 80px 40px;
    box-sizing: border-box;
`;

export const TableWrapper = styled.div`
    background: ${colorsPalettes.carbon[0]};
    border-radius: 6px;

    .ant-table {
        .ant-table-content {
            overflow: hidden !important;
        }
        
        .ant-table-row {
            cursor: pointer;
        }
    }
`;

export const EllipsisDropdownItemStyled = styled(EllipsisDropdownItem)`
    svg {
        height: 100%;
        width: 100%;
        fill: ${colorsPalettes.carbon[200]};
    }
`;
